import { createContext, useContext } from "react";
import { ContextProviderProps } from '../types/chat.types';

const ChatContext = createContext<Omit<ContextProviderProps, 'children'> | undefined>(undefined);

export const useChatContext = () => {
    const context = useContext(ChatContext);
    if (!context) {
        throw new Error("useChatContext must be used within a Chat.ContextProvider");
    }
    return context;
};

export default ChatContext;